import React from "react";
import logo from "../assets/about2.jpg"; // Logo içerden çekiliyor

const AboutSection = () => {
  return (
    <section id="about" className="bg-white py-12">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-gray-800 text-center mb-8">
          Hakkımızda
        </h2>
        <div className="flex flex-col lg:flex-row items-center">
          <div className="lg:w-1/2 mb-8 lg:mb-0">
            <img src={logo} alt="Hakkımızda" className="rounded-lg shadow-md" />
          </div>
          <div className="lg:w-1/2 lg:pl-12">
            <p className="text-gray-600 mb-4">
                Softrein, üretim sektöründe dijital dönüşüm ve operasyonel
              mükemmeliyet hedefleyen bir teknoloji firmasıdır. Kuruluşumuzdan
              itibaren, inovasyon ve müşteri odaklı çözümlerle işletmelerin
              teknolojik altyapılarını güçlendirme misyonuyla hareket ediyoruz.
              MES, ERP ve MRP sistem entegrasyonları, elektronik kart tasarımı
              ve dijitalleşme projelerinde sunduğumuz uzmanlık sayesinde,
              müşterilerimizin üretim süreçlerini verimli, sürdürülebilir ve
              rekabetçi bir yapıya dönüştürüyoruz.
            </p>
            <p className="text-gray-600 mb-4">
                Alanında deneyimli ekibimiz, her projeyi sadece bir iş olarak
              değil, uzun vadeli iş birliklerinin temeli olarak görmektedir. Bu
              anlayışla, her müşterimize özel ve yenilikçi çözümler sunarak
              işletmelerin küresel standartlarda faaliyet göstermelerine destek
              oluyoruz. Teknolojinin sınırlarını zorlayarak, güvenilir, esnek ve
              yenilikçi yapılar oluşturmayı kendimize hedef ediniyoruz.
            </p>
            <p className="text-gray-600">
                Softrein olarak, üretimde sürdürülebilirlik ve teknolojik liderlik
              vizyonumuzla, projelerinizi hayata geçirirken yanınızda olmaktan
              gurur duyuyoruz.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
